// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"b73bb75e315e035a3f76","715":"f299f03eead32a9f04a2","962":"48b514212e877dda4b48"}[chunkId] + ".css";
};